import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import UserDefine from '@/assets/config/user-define.json';
import { EventEmitter } from 'events';
import store from '@/trust-atcs-app/store';
import { RouteN } from '@/trust-atcs-app/constants/router-name';

@Options({})
export default class ApplicationMenuComponent extends Vue {

  @Prop({ required: true })
  public show!: boolean;

  @Prop({ default: null })
  private isExternal!: boolean;

  // get userAccount(): UserAccount {
  //   return this.$store.getters.getUserAccount;
  // }

  // get RouteN(): RouteName {
  //   return RouteN;
  // }

  // get Section(): SectionName {
  //   return Section;
  // }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private goToFAQ() {
    window.open(UserDefine[0].faq_atcs_url, 'blank');
  }

  private goToContactUs() {
    window.open(UserDefine[0].contact_us_url, 'blank');
  }

  private signOut() {
    this.$router.push({ name: RouteN.ATCS.LogoutPage.n });
  }

}
